module.exports = __webpack_public_path__ + "img/location_menu.5199389f.jpg";